import { Template } from "./Template.js";
import { TemplateValue } from "./TemplateValue.js";

/**
 * Prefills certain fields in the given template.
 */
export const prefillTemplate = (
  template: Template,
  id: string,
  name: string,
  prefills: TemplateValue[],
  initialValues: TemplateValue[] = []
) => {
  const clone: Template = {
    id,
    name,
    variables: template.variables.filter((variable) =>
      prefills.every((value) => value.name !== variable.name)
    ),
    initialValues: [...initialValues, ...(template.initialValues ?? [])],
    generate: (values) => template.generate([...values, ...prefills])
  };

  return clone;
};
